import React, { Component } from 'react';
import { Link } from 'gatsby';

class PaginationNav extends Component 
{
    constructor(props) {
        super(props);

        this.state = {
            navLength: 3,
            categorySlug: this.props.categorySlug.length > 1 ? "all" : this.props.categorySlug[0]
        };
    }

    previousPage = () => {
        if (this.props.currentPage === 2)
            return "";

        return this.props.currentPage - 1;
    }

    formUrl = (urlSlug, categorySlug, page) => {
        if (categorySlug === "all")
            return `${ urlSlug }/${ page }`;

        return `${ urlSlug }/${ categorySlug }/${ page }`;
    }

    render () {
        let urlSlug = this.props.urlSlug;

        return (
            <div className='pagination-container'>
                <div className='pagination-nav'>
                    { this.props.currentPage > 1 ?
                        <Link 
                            to={ this.formUrl(urlSlug, this.state.categorySlug, this.previousPage()) }
                            className="filled-button button-purple-pink"
                        >
                            Prev
                        </Link>
                    : 
                        null
                    }
                    <PaginationNavList 
                        currentPage={ this.props.currentPage } 
                        pageCount={ this.props.pageCount } 
                        navLength={ this.state.navLength } 
                        urlSlug = { urlSlug }
                        categorySlug={ this.state.categorySlug }
                        formUrl ={ this.formUrl.bind(this) }
                    />
                    { this.props.currentPage < this.props.pageCount ?
                        <Link 
                            to={ this.formUrl(urlSlug, this.state.categorySlug, this.props.currentPage + 1) } 
                            className="filled-button button-purple-pink"
                        >
                            Next
                        </Link>
                    : 
                        null
                    }
                </div>
            </div>
        );
    }
}

export default PaginationNav;

class PaginationNavList extends Component 
{
    render () {
        let currentPage = this.props.currentPage;
        let pageCount = this.props.pageCount;
        let navLength = this.props.navLength;

        var lastPage = currentPage + navLength;
        if (lastPage > pageCount)
            lastPage = pageCount;

        var items = [];
        for (var i = currentPage; i < lastPage; i++)
            items.push(<PaginationNavItem 
                pageNumber={ i } current={ i === currentPage } urlSlug={ this.props.urlSlug } categorySlug={ this.props.categorySlug } formUrl={ this.props.formUrl } key={ this.props.categorySlug + "_" + i } />);

        return (
            <div className='pagination-nav-items'>
                { items }
                {(this.props.pageCount > 1) 
                    ?
                        <div className='pagination-nav-items-separator'>
                            <span>...</span>
                        </div>
                    : null
                }
                <PaginationNavItem 
                    pageNumber = { pageCount } current={ pageCount === 1 ? true : false } urlSlug={ this.props.urlSlug } categorySlug={ this.props.categorySlug } formUrl={ this.props.formUrl } />
            </div>
        );
    }
}

class PaginationNavItem extends Component
{
    render () {
        let pageNumber = this.props.pageNumber;
        let isCurrent = this.props.current;
        let urlSlug = this.props.urlSlug;
        let categorySlug = this.props.categorySlug;

        return (
            <div className={`pagination-nav-items-item sign-up-button sign-up-right button-white-pink ${ isCurrent ? 'pagination-nav-items-item-active' : '' }`}>
                <div className={`pagination-nav-items-item-content ${ isCurrent ? 'pagination-nav-active' : '' }`}>
                    {
                        (pageNumber > 1)
                            ?
                                <Link 
                                    to={ this.props.formUrl(urlSlug, categorySlug, pageNumber) } 
                                    dangerouslySetInnerHTML={{ __html: pageNumber }}>
                                </Link>
                            :
                                <span className='pagination-nav-items-item-disabled'
                                    dangerouslySetInnerHTML={{ __html: pageNumber }}>
                                </span>
                    }
                </div>
            </div>
        );
    }
}